import { combineReducers } from 'redux';
import contatoActions, { reducer as contatoReducer } from './contatoStore';
import menuActions, { reducer as menuReducer } from './sidemenuStore';
import loginActions, { reducer as loginReducer } from './loginStore';
import applicationLoadingActions, { applicationLoadingReducer } from './applicationLoading';


export default combineReducers({
    login: loginReducer,
    contatos: contatoReducer,
    menu: menuReducer,
    isApplicationLoading: applicationLoadingReducer,
});

export {
    loginActions,
    contatoActions,
    menuActions,
    applicationLoadingActions,
};


// WEBPACK FOOTER //
// ./src/redux/index.js